import {CookieHelper} from "../xscf";


// iuap-tns.share-fe公共三方包制品的访问路径，专属化是相对路径，公有云会被替换为cdn域名路径
export const TNS3ND_CONTEXT = "/iuap-tns/ucf-wh/share/";
// export const TNS3ND_CONTEXT = "https://design.yonyoucloud.com/static/ucf/iuap-tns.share-fe/20230412-180545/"; //替换成CDN的场景-本地测试用

// 获取加载tnsSdk.js的script标签
export const getTnsSdkScript = function(){
    let scripts = document.getElementsByTagName("script");
    for (let i = 0; i < scripts.length; i++) {
        let iUrl = scripts[i].src;
        const sdkPattern = /\/share\/runtime\/tnsSdk(-\d+)?\.js/;
        //通过匹配查找包含tnsSdk.js路径的script
        if (sdkPattern.test(iUrl)){
            return scripts[i];
        }
    }
}
let TNS_SDK_SCRIPT_URL; // 缓存url，减少document.getElementsByTagName次数。
// 获取加载tnsSdk.js的script标签src
export const getTnsSdkScriptSrc = function(){
    if(!TNS_SDK_SCRIPT_URL){
        const srcipt = getTnsSdkScript();
        TNS_SDK_SCRIPT_URL = srcipt && srcipt.src;
    }
    return TNS_SDK_SCRIPT_URL;
}

// 字符串拼接的情况不会被替换为CDN地址，所以两者进行对比即可判断出是启用CDN域名
export const isEnableCdn = function(){
    let relUrl = ["/iuap-tns","/ucf-wh/","share/"].join("");
    // return (relUrl!==TNS3ND_CONTEXT);
    return !(TNS3ND_CONTEXT.includes(relUrl));
}

// 打印调试日志
const isTnsDebug = CookieHelper.read("tnsDebug")?true:false; // cookie存在tnsDebug值则打印debug日志。
export const debugLog = function(){
    isTnsDebug && console.log(...arguments);
}

// 加载去iframe的小应用模块入口
export const getOrLoadModulePromise = function(_remote, _shareScope, _remoteUrl){
    let remote = _remote, shareScope = _shareScope, remoteUrl = _remoteUrl;
    return new Promise(function(resolve, reject) {
        //------------ 1.已存在则直接返回 ------------
        if(window[remote]){
            resolve(window[remote]);
            return;
        }
        //------------ 2.不存在（初次加载、未加载完成）------------
        // 当加载完成时触发
        const onLoad = function (originOnload){
            return async function(){
                // 新实现：加载去iframe小应用后，不再重新初始化。
                if (!window[remote].loadBy) {
                    await __webpack_init_sharing__('default');
                    await window[remote].init(__webpack_share_scopes__.default);
                    window[remote].loadBy = 'MainApplication';
                    resolve(window[remote]);
                    originOnload && originOnload();
                }

                // 原本实现：加载去iframe小应用后进行默认共享范围的init
                // if (!window[remote].__initialized) {
                //     // if share scope doesnt exist (like in webpack 4) then expect shareScope to be a manual object
                //     // var wShareScope = (typeof __webpack_share_scopes__ === 'undefined')?shareScope.default:__webpack_share_scopes__[shareScope];
                //     let wShareScope;
                //     if (__webpack_share_scopes__ && __webpack_share_scopes__[shareScope]) {
                //         // use default share scope object passed in manually
                //         wShareScope = __webpack_share_scopes__[shareScope];
                //     } else {
                //         // otherwise, init share scope as usual
                //         wShareScope = __webpack_share_scopes__;
                //     }
                //
                //     // module.init(__webpack_require__.S[name], initScope);
                //     // var shareScope = __webpack_require__.S['default'];
                //     // resolve(window[remote])
                //     // var initResult = window[remote].init(__webpack_share_scopes__.default);
                //     window.TNS2ND_SHARE_SCOPE = wShareScope; // 记录当前二方包资源共享范围
                //     let initResult = window[remote].init(wShareScope);
                //     if(initResult === 1){ // 无其它异步资源依赖的情况会返回 1
                //         window[remote].__initialized = true;
                //         resolve(window[remote]);
                //         originOnload && originOnload();
                //     }else if(initResult.then){ // 存在其它异步资源依赖的情况会返回 Promise
                //         initResult.then().finally(()=>{
                //             window[remote].__initialized = true;
                //             resolve(window[remote]);
                //             originOnload && originOnload();
                //         })
                //     }
                // }
            }
        };
        // 当加载失败时触发
        const onFail = function(remote,originFail){
            let scriptRemote = remote;
            return function (){
                let d = document.querySelector(`script[data-tns-remote="${scriptRemote}"]`);//将出错的script清理
                d && document.head.removeChild(d);
                reject(`load remote is error :${remote} (${remoteUrl})`);
                originFail && originFail();
            }
        }
        if(!remoteUrl){
            onFail(remote)();
            return;
        }
        let remoteScript = document.querySelector(`script[data-tns-remote="${remote}"]`);
        if(!remoteScript) {//script不存在则为初次加载
            let script = document.createElement('script');
            script.type = 'text/javascript';
            // mark as data-webpack so runtime can track it internally
            script.setAttribute('data-tns-remote', `${remote}`);
            script.async = true;
            script.src = remoteUrl;
            script.onerror = onFail(remote);
            script.onload = onLoad(null);
            remoteScript = script;
            document.head.appendChild(remoteScript);
        } else {//script存在则为未加载完成
            // console.log("AAA---existingRemote--->"+remote)
            remoteScript.onerror = onFail(remote,remoteScript.onerror);
            remoteScript.onload = onLoad(remoteScript.onload);
        }
    });
}


// 是否为绝对url地址 begins with "<scheme>://" or "//" (protocol-relative URL)
export function isAbsoluteURL(url) {
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
}

// 获取相对路的url，即排除（https，http）和host
export function getRelativeURL(url){
    let refUrl = url;
    if(isAbsoluteURL(url)){
        try{
            let urlObj = new URL(url);
            let {pathname,search} = urlObj;
            refUrl = pathname+search;
        }catch (e) {}
    }
    return refUrl;
}

/**
 * 解析标准的URL
 *  var myURL = parseURL('http://abc.com:8080/dir/index.html?id=255&m=hello#top');
 *  myURL.file = 'index.html'
 *  myURL.hash = 'top'
 *  myURL.host = 'abc.com'
 *  myURL.query = '?id=255&m=hello'
 *  myURL.params = Object = { id: 255, m: hello }
 *  myURL.path = '/dir/index.html'
 *  myURL.segments = Array = ['dir', 'index.html']
 *  myURL.port = '8080'
 *  myURL.protocol = 'http'
 *  myURL.relative = '/dir/index.html?id=255&m=hello#top'
 *  myURL.source = 'http://abc.com:8080/dir/index.html?id=255&m=hello#top'
 * @param url
 * @returns {{source: *, protocol, host, port, query, params, file: string, hash, path, relative: string, segments}}
 */
export function parseURL(url) {
    var a = document.createElement('a');
    a.href = url;
    var uri = {
        source: url,
        protocol: a.protocol.replace(':', ''),
        host: a.hostname,
        port: a.port,
        query: a.search,
        params: (function () {
            var ret = {},
                seg = a.search.replace(/^\?/, '').split('&'),
                len = seg.length, i = 0, s;
            for (; i < len; i++) {
                if (!seg[i]) {
                    continue;
                }
                s = seg[i].split('=');
                ret[s[0]] = s[1];
            }
            return ret;
        })(),
        file: (a.pathname.match(/\/([^\/?#]+)$/i) || [, ''])[1],
        hash: a.hash.replace('#', ''),
        path: a.pathname.replace(/^([^\/])/, '/$1'),
        relative: (a.href.match(/tps?:\/\/[^\/]+(.+)/) || [, ''])[1],
        segments: a.pathname.replace(/^\//, '').split('/')
    };
    uri.hostDomain = `${uri.protocol}://${uri.host}${uri.port?":"+uri.port:''}`;
    return uri;
}

const loadRemoteInProgress = {};
// 动态加载远程脚本
export function loadRemoteScript(url, done, key){
    if(loadRemoteInProgress[url]){loadRemoteInProgress[url].push(done);return;} //防止高并发重复加载
    let script, needAttach;
    if(key !== undefined) {
        let scripts = document.getElementsByTagName("script");
        for(let i = 0; i < scripts.length; i++) {
            let s = scripts[i];
            if(s.getAttribute("src") == url || s.getAttribute("tns-remote-script") == key) { script = s; break; }
        }
    }
    if(!script) {
        needAttach = true;
        script = document.createElement('script');
        script.charset = 'utf-8';
        script.timeout = 120;
        script.setAttribute("tns-remote-script", key);
        script.src = url;
    }
    loadRemoteInProgress[url] = [done];
    let onScriptComplete = (prev, event) => {
        // avoid mem leaks in IE.
        script.onerror = script.onload = null;
        clearTimeout(timeout);
        let doneFns = loadRemoteInProgress[url];
        delete loadRemoteInProgress[url];
        script.parentNode && script.parentNode.removeChild(script);
        doneFns && doneFns.forEach((fn) => (fn(event)));
        if(prev) return prev(event);
    };
    let timeout = setTimeout(onScriptComplete.bind(null, undefined, { type: 'timeout', target: script }), 120000);
    script.onerror = onScriptComplete.bind(null, script.onerror);
    script.onload = onScriptComplete.bind(null, script.onload);
    needAttach && document.head.appendChild(script);
}

// 全局promise缓存
const promiseCache = getTnsSdkCacheGroup("loadPromise");
const promiseIndexCache = getTnsSdkCacheGroup("loadPromiseIndex",[]);
//注意：缓存操作必须为同步方法。 promise加载的缓存 - 确保同一个promise执行一次，存在则从缓存获取，不存在则创建默认promise
function getPromiseFromCache(promiseName, createDefaultPromise) {
    let promise = promiseCache[promiseName];
    if (!promise) {
        // console.log('AAA--singlePromise--新建--->'+promiseName);
        if (promiseName && promiseName.startsWith("asyncLoadPackage")) {
            // 创建新 Promise 但不立即缓存
            const newPromise = createDefaultPromise();
            // 成功时缓存 Promise
            newPromise
                .then(() => {
                    promiseCache[promiseName] = newPromise;
                    promiseIndexCache.push(promiseName);
                })
                .catch((error) => {
                    // 报错时不缓存，让下次调用可以重新尝试
                    console.log(`Promise ${promiseName} failed:`, error);
                    newPromise.catch = null;
                    newPromise.then = null;
                });
            return newPromise;
        } else {
            promiseIndexCache.push(promiseName);
            promise = promiseCache[promiseName] = createDefaultPromise();
        }
    } else {
        // console.log('AAA--singlePromise--复用--->'+promiseName);
    }
    return promise;
}

// promise单例 - 用于并发情况下使用同一个promise
export async function createSinglePromise(promiseName,createDefaultPromise){
    let cachePromise = getPromiseFromCache(promiseName,createDefaultPromise) // 注意：写入缓存要走同步方法。
    return await cachePromise;
}

// 获取tnsSdk缓存组，注意：必须为同步方法。
export function getTnsSdkCacheGroup(cacheGroupName,defaultValue){
    window.__tnsSdkCache__ = window.__tnsSdkCache__ || defaultValue || {};
    window.__tnsSdkCache__[cacheGroupName] = window.__tnsSdkCache__[cacheGroupName] || defaultValue || {};
    return window.__tnsSdkCache__[cacheGroupName];
}
